export default __webpack_public_path__ + "static/media/PRIMARY-FONT.263ca25a.png";